import { finishCodesMatch } from "./finishCode.js";

export type FamilyFinishMember = {
  member_id: string;
  material_id: string;
  finish_code: string | null;
};

export type FamilyFinishOption = {
  material_use_id: string;
  use_code: string;
  members?: readonly FamilyFinishMember[];
};

/** Each length in the family takes its own member that carries this finish code. */
export function assignFinishAcrossFamily(args: {
  materialUseIds: readonly string[];
  options: readonly FamilyFinishOption[];
  finishCode: string;
  pendingMemberId: string;
}): { assignments: Array<{ material_use_id: string; material_id: string }>; missing: string[] } {
  const assignments: Array<{ material_use_id: string; material_id: string }> = [];
  const missing: string[] = [];
  for (const useId of args.materialUseIds) {
    const option = args.options.find((row) => row.material_use_id === useId);
    const members = option?.members ?? [];
    const pending = args.pendingMemberId ? members.find((member) => member.member_id === args.pendingMemberId) : undefined;
    if (pending) {
      assignments.push({ material_use_id: useId, material_id: pending.material_id });
      continue;
    }
    const matches = members.filter((member) => finishCodesMatch(member.finish_code, args.finishCode));
    if (matches.length === 1) {
      assignments.push({ material_use_id: useId, material_id: matches[0]!.material_id });
      continue;
    }
    missing.push(option?.use_code || useId);
  }
  return { assignments, missing };
}
